import { render, staticRenderFns } from "./MonthlyAmountInput.vue?vue&type=template&id=6d36c561&scoped=true&"
import script from "./MonthlyAmountInput.vue?vue&type=script&lang=js&"
export * from "./MonthlyAmountInput.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyAmountInput.vue?vue&type=style&index=0&id=6d36c561&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d36c561",
  null
  
)

export default component.exports